import { useRanchesByCustomer } from '../../../../services/entities/hooks/useRanchesByCustomer';
import { useVariety } from '../../../../services/entities/hooks/useVariety';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { useDownloadCsv } from '../../../duckDB/hooks/useDownloadCsv';
import { createInlineMappingSubquery } from '../../../duckDB/utils/createInlineMappingSubquery';
import { formattedDateColumn } from '../../../duckDB/utils/formattedDateColumn';
import { sizeBucketLabelMap } from '../components/Charts/SizeBucket';

export const useDownloadSizeReport = (
  customerId: string,
  varietyId: string | undefined,
  shouldUpdate: boolean
) => {
  const { t } = useTranslation();

  const { variety } = useVariety(varietyId);

  const { ranches, isRanchesLoading } = useRanchesByCustomer(customerId);

  return useDownloadCsv(
    `(SELECT
      ${formattedDateColumn('report.scan_date')} as '${t('Scan Date')}', 
      ranches.name as '${t('Ranch')}',
      report.block_name as '${t('Block')}', 
      ${
        // TODO: make a hook to query the size buckets actually present in the data
        Object.keys(sizeBucketLabelMap)
          .map(
            (sizeBucket) =>
              `CAST(round(CAST(report.size_deduplicated_counts->>'$.${sizeBucket}' AS FLOAT), 0) AS INTEGER) as '${sizeBucketLabelMap[sizeBucket]}'`
          )
          .join()
      },
      CAST(round(list_sum(
        list_transform(json_keys(report.size_deduplicated_counts), 
        k -> json_extract(report.size_deduplicated_counts,k)::FLOAT)), 0) AS INTEGER) as '${t(
          'Total Count'
        )}'
      FROM size_report_table report
      LEFT JOIN ${createInlineMappingSubquery(ranches, ['id', 'name'])} ranches 
      ON (report.ranch_id = ranches.id)
      ORDER BY report.scan_date)`,
    `${variety?.name.toLowerCase() ?? 'blueberry'}_${t(
      'size report'
    ).replaceAll(' ', '_')}`,
    shouldUpdate && !isRanchesLoading
  );
};
